// extracted by mini-css-extract-plugin
export default {"PFSPrivacyPolicy":"PFSPrivacyPolicy_PFSPrivacyPolicy__cwKW1"};